import React from 'react'
import { FinanceInfo, FinanceInfoKey, FinanceInfoValue, FinanceTypePill } from './finance-representative-example.styles'

export const FinanceRepresentativeExample = ({ value, title }: { value: string; title: string }) => {
    return (
        <FinanceInfo>
            <FinanceInfoKey as="span">{title}</FinanceInfoKey>
            {title === 'Finance type' ? (
                <FinanceTypePill>{value}</FinanceTypePill>
            ) : (
                <FinanceInfoValue as="span">{value}</FinanceInfoValue>
            )}
        </FinanceInfo>
    )
}
